var _path, _path2, _g, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentZt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.37922C0 1.45138 0.752162 0.699219 1.68 0.699219H8.48C8.93978 0.699219 9.37946 0.887656 9.69655 1.2206L11.5366 3.1526C11.8341 3.46498 12 3.87983 12 4.31122V11.6192C12 12.5471 11.2478 13.2992 10.32 13.2992H1.68C0.752162 13.2992 0 12.5471 0 11.6192V2.37922Z",
    fill: "#7BDBA6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_136565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.37922C0 1.45138 0.752162 0.699219 1.68 0.699219H8.50412C8.94969 0.699219 9.377 0.876218 9.69206 1.19128L11.5079 3.00716C11.823 3.32222 12 3.74953 12 4.1951V11.0192C12 11.9471 11.2478 12.6992 10.32 12.6992H1.68C0.752162 12.6992 0 11.9471 0 11.0192V2.37922Z",
    fill: "#7BDBA6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_136565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80078 -1.7998L14.8008 4.2002H10.0008C9.33804 4.2002 8.80078 3.66294 8.80078 3.0002V-1.7998Z",
    fill: "#BAECD1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35938 4.47949H6.71937",
    stroke: "#EAFFF4",
    strokeWidth: 1.4028,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35938 6.99902H9.23937",
    stroke: "#EAFFF4",
    strokeWidth: 1.4028,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35938 9.51855H9.23937",
    stroke: "#EAFFF4",
    strokeWidth: 1.4028,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentZt);
export default __webpack_public_path__ + "static/media/comment_zt.e0818141fc5003989fb366a304bdfe9e.svg";
export { ForwardRef as ReactComponent };